import MorableButton from "@components/moreable_button";
import AnimateHeight from "@components/react-animate-height";
import { useTranslation } from "react-i18next";
import { Checkbox } from "antd";
import { useState, useEffect } from "react";

const AccommodationBox = ({
  data,
  handleFilterSelection,
  isFiltersLoadingInline,
  selectedFilters,
}) => {
  const [isSeeMore, setIsSeeMore] = useState(false);
  const { t, i18n } = useTranslation("common");
  const isEn = i18n.language === "en";

  useEffect(() => {
    setIsSeeMore(selectedFilters?.length > 0);
  }, [selectedFilters]);

  const handleCheck = (e) => {
    e?.stopPropagation();
    const value = e?.target?.value;
    const isChecked = e?.target?.checked;

    handleFilterSelection("roomType", value, isChecked);
  };

  const renderContent = () =>
    data?.map((item) => (
      <Checkbox
        key={item?.alias + item?.count}
        className="search_checkbox w-full mb-[8px] !ml-0"
        onChange={handleCheck}
        disabled={isFiltersLoadingInline}
        value={item?.alias}
        checked={selectedFilters?.includes(item?.alias)}
      >
        <p
          className={`text-base text-left ${
            selectedFilters?.includes(item?.alias)
              ? "font-medium"
              : "font-normal"
          }`}
        >
          {isEn
            ? item?.title_en ?? item?.title_de
            : item?.title_de ?? item?.title_en}
          {item?.count && ` (${item?.count})`}
        </p>
      </Checkbox>
    ));

  return (
    <article className="w-full border-t-green border-t-4 py-3 lg:px-5 px-4 border rounded-2xl">
      <h3 className="font-bold text-lg mb-[10px]">
        {t("search.filter_Unterkunftsart")}
      </h3>

      <div className="w-full">
        {data?.length >= 5 ? (
          <div>
            <AnimateHeight
              duration={500}
              height={isSeeMore ? "auto" : 115}
              className="[&_.g-container]:!h-[35px]"
            >
              {renderContent()}
            </AnimateHeight>

            <MorableButton
              underline={true}
              isOpen={isSeeMore}
              onClick={() => setIsSeeMore((prev) => !prev)}
              allNumber={data.length}
            />
          </div>
        ) : (
          renderContent()
        )}
      </div>
    </article>
  );
};

export default AccommodationBox;
